import * as React from "react";
const SvgMissionFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M19.5 16a1.5 1.5 0 0 1 0 3h-16a1.5 1.5 0 0 1 0-3zm-8-12a1 1 0 0 1 1 1l.001 1.062A8 8 0 0 1 19.5 14a1 1 0 0 1-1 1H4.444a1 1 0 0 1-1-1c0-4.073 3.096-7.447 7.057-7.938L10.5 5a1 1 0 0 1 1-1", clipRule: "evenodd" }));
export default SvgMissionFill;
